<template>
    <div v-show="panel_required">
        <div class="designeroption" :data-designer-component-id="component_id">
            <h3>{{ title }}</h3>
            <div class="stylesoption">
                <div class="form-group">
                    <input type="text" v-model="localTarget.text" id="side_glass_text" class="form-control">
                    <div class="txt-sm txt-light mt-1"><span id="remain">{{ limit_input }}</span> characters remaining.</div>
                </div>
                <div v-show="panel_select_required" class="form-group mt-3">
                    <label>Select Panel For Text</label>
                    <select class="form-control" v-model="localTarget.position">
                        <option v-for="option in options" :value="option">{{ option }} Panel</option>
                    </select>
                </div>
                <div class="txt-sm txt-light mt-1" v-show="helper_text"><em>{{ helper_text }}</em></div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        props: {
            title: {
                default(){
                    return 'Side glass text';
                }
            },
            component_id: {
                default(){
                    return 'side_glass_text';
                }
            },
            target: {
                required: true,
            },
            leftPanelGlass: {
                required: true,
            },
            rightPanelGlass: {
                required: true,
            },
            topPanelGlass: {
                required: true,
            },
            max_char: {
                default(){
                    return 3;
                }
            },
            helper_text: {
                default(){
                    return false;
                }
            }
        },
        data(){
            return {
                options: [],
                fetchData: window._.debounce(function() {
                    window.axios.post('/api/get-side-glass-text-options', {
                        left: this.leftPanelGlass,
                        right: this.rightPanelGlass,
                        top: this.topPanelGlass,
                    })
                    .then((response) => {
                        this.options = response.data;
                        if (this.panel_required && !this.panel_select_required) {
                            this.localTarget.position = this.options[0];
                        } else {
                            this.localTarget.position = null;
                            this.localTarget.text = '';
                        }
                    });
                }, 750)
            }
        },
        computed: {
            localTarget: {
                get() {
                    return this.target
                },
                set(val) {
                    if(this.target !== val) {
                        this.$emit('update:target', val)
                    }
                }
            },
            passed_filter(){
                return this.variable_ready(this.leftPanelGlass, this.rightPanelGlass, this.topPanelGlass);
            },
            url(){
                return '/api/options/' + this.fabricator + '/side-glass-text?left_panel_glass=' + this.leftPanelGlass + '&right_panel_glass=' + this.rightPanelGlass + '&top_panel_glass=' + this.topPanelGlass;
            },
            cache_key(){
                return '_' + this.leftPanelGlass + '_' +  this.rightPanelGlass + '_' +  this.topPanelGlass;
            },
            panel_required(){
                return this.filtered_options && this.filtered_options.length > 0;
            },
            panel_select_required(){
                return this.filtered_options && this.filtered_options.length > 1;
            },
            limit_input(){
                if(this.localTarget.text === null){
                    return this.max_char;
                }

                if (this.localTarget.text.length >= this.max_char) {
                    $('#side_glass_text').val($('#side_glass_text').val().substring(0, this.max_char));
                }
                if ((this.max_char - this.localTarget.text.length) < 1) {
                    return 0;
                }
                return this.max_char - this.localTarget.text.length;
            },
            filtered_options(){
                return this.options.filter(function (el) {
                    return el !== "";
                });
            }
        },
        watch: {
            'leftPanelGlass': function (val, oldVal) {
                this.fetchData();
            },
            'rightPanelGlass': function (val, oldVal) {
                this.fetchData();
            },
            'topPanelGlass': function (val, oldVal) {
                this.fetchData();
            },
            'localTarget.text': {
              handler: window._.debounce(function () {
                // if localTarget.text is not null, replace any characters that are not letters, numbers, spaces or periods with an empty string
                if (this.localTarget.text !== null) {
                    this.localTarget.text = this.localTarget.text.replace(/[^a-zA-Z0-9. ]+/g," ");
                }
              }, 50),
            },
        },
        mounted(){
            this.fetchData();
        },
        methods: {
            variable_ready(...vars) {
                var found_value = vars.findIndex((val) => {
                    return val === undefined || val === null;
                });

                return found_value === -1;
            },
        },
    }
</script>
